<template>
  <v-card class="mx-auto" width="90%" style="margin-bottom: 15px; margin-top: 20px;">
    <v-toolbar
      flat
      color="primary"
      dark
    >
      <v-toolbar-title>{{ $t('views.stats.title') }}</v-toolbar-title>
    </v-toolbar>
    <v-tabs horizontal>
      <v-tab>
        <v-icon left>
          mdi-head-snowflake
        </v-icon>
        {{ $t('views.stats.ekrmTab') }}
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-data-table
              :items="ekrmMetrics"
              :headers="ekrmMetricsHeaders"
              style="width: 100%;"
              sort-by="date_created"
              :sort-desc="true"
              :items-per-page="50"
              item-key="codename"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-btn :href="ekrmMetricsExportLink" :download="`ekrm_stats_export_${ timestamp }.csv`" small color="#212121" class="white--text">
                    <v-icon class="align-center" color="primary">mdi-export</v-icon>
                    <span class="pl-2">{{ $t('views.stats.export') }}</span>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.date_created="{ item }">
                {{ dateCreatedTable(item) }}
              </template>
              <template v-slot:item.reference_model.definition.reference.category="{ item }">
                {{ item.reference_model.definition.reference.category }}
              </template>
          </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab>
        <v-icon left>
          mdi-file-tree
        </v-icon>
        {{ $t('views.stats.referenceModelsTab') }}
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-data-table
              :items="referenceMetrics"
              :headers="referenceMetricsHeaders"
              style="width: 100%;"
              sort-by="date_created"
              :sort-desc="true"
              :items-per-page="50"
              item-key="id"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-btn :href="referenceMetricsExportLink" :download="`reference_stats_export_${ timestamp }.csv`" small color="#212121" class="white--text">
                    <v-icon class="align-center" color="primary">mdi-export</v-icon>
                    <span class="pl-2">{{ $t('views.stats.export') }}</span>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.date_created="{ item }">
                {{ dateCreatedTable(item) }}
              </template>
          </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      ekrmMetricsExportLink: '',
      referenceMetricsExportLink: ''
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ]),
    ...mapGetters('clients', [
      'currentClientObject'
    ]),
    ...mapGetters('metrics', [
      'ekrmMetrics',
      'referenceMetrics'
    ]),
    timestamp () {
      return new Date().toISOString()
    },
    ekrmMetricsHeaders () {
      return [
        { text: this.$t('views.stats.headerModel'), value: 'name' },
        { text: this.$t('views.stats.headerDateCreated'), value: 'date_created' },
        { text: this.$t('views.stats.headerCreatedBy'), value: 'created_by' },
        { text: this.$t('views.stats.headerReference'), value: 'reference_model.definition.reference.category' },
        { text: this.$t('views.stats.headerCountry'), value: 'custom_model.country' }
      ]
    },
    referenceMetricsHeaders () {
      return [
        { text: this.$t('views.stats.headerReferenceId'), value: 'id' },
        { text: this.$t('views.stats.headerCategory'), value: 'category' },
        { text: this.$t('views.stats.headerDateCreated'), value: 'date_created' },
        { text: this.$t('views.stats.headerCreatedBy'), value: 'created_by' },
        { text: this.$t('views.stats.headerCustomModelsCount'), value: 'customModelCount' },
        { text: this.$t('views.stats.headerCountLast90Days'), value: 'customModelCountLast90Days' }
      ]
    }
  },
  methods: {
    ...mapActions('metrics', [
      'loadEkrmMetrics',
      'loadReferenceMetrics'
    ]),
    dateCreatedTable (item) {
      return item.date_created.toDate().toString().slice(4, 24)
    },
    dateCreatedCsv (item) {
      return item.date_created.toDate().toISOString().slice(0, 10)
    },
    exportEkrmMetrics () {
      const titles = this.ekrmMetricsHeaders.map(item => item.text)
      let csv = titles.join(',') + '\n'
      this.ekrmMetrics.forEach(item => {
        csv += ([item.name, this.dateCreatedCsv(item), item.created_by, item.reference_model.definition.reference.category, item.custom_model.country]).join(',') + '\n'
      })
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8,' })
      this.ekrmMetricsExportLink = URL.createObjectURL(blob)
    },
    exportReferenceMetrics () {
      const titles = this.referenceMetricsHeaders.map(item => item.text)
      let csv = titles.join(',') + '\n'
      this.referenceMetrics.forEach(item => {
        csv += ([item.id, item.category, this.dateCreatedCsv(item), item.created_by, item.customModelCount, item.customModelCountLast90Days]).join(',') + '\n'
      })
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8,' })
      this.referenceMetricsExportLink = URL.createObjectURL(blob)
    }
  },
  components: {},
  created: async function () {
    await this.loadEkrmMetrics()
    this.exportEkrmMetrics()
    await this.loadReferenceMetrics()
    this.exportReferenceMetrics()
  }
}
</script>
